<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useStore} from "vuex";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {Share} from "@capacitor/share";

export default {
  name: "MyProfile",
  components: {LoadingPage},
  setup() {

    let store = useStore()
    let loading = ref(false)
    let my_info = ref(FreeWorld.PinkMan(store.state.profile, 'de'))

    let country = ref(FreeWorld.PinkMan(store.state.country, 'de'))
    let city = ref([])


    function chang_states(type) {

      switch (type) {
        case 'first':
          country.value.forEach((item) => {
            if (item.id === my_info.value.state_id) {
              city.value = item.city
            }
          })
          break;

        case 'state':
          country.value.forEach((item) => {
            if (item.id === my_info.value.state_id) {
              my_info.value.state = item.name
              city.value = item.city
              if (city.value[0]) {
                my_info.value.city_id = city.value[0].id
                my_info.value.city = city.value[0].name
              }
              return false
            }
          })
          break;

        case 'city':
          city.value.forEach((item) => {
            if (item.id === my_info.value.city_id) {
              my_info.value.city = item.name
              return false
            }
          })
          break;
      }

    }

    chang_states('first')

    function edit_user() {

      // let data = JSON.parse(JSON.stringify(my_info.value))
      // let x = ['city' , 'created_at' , 'id' , 'state' , 'status' , 'updated_at' , 'users_type_id' , 'ref_code' , 'user_code']
      //
      // x.forEach((item)=>{
      //   delete data[item]
      // })

      my_info.value.action = 'user'

      loading.value = true
      FreeWorld.Heisenberg(my_info.value, 'edit_account', true).then((res) => {
        loading.value = false
        if (res.data.status === 'ok') {
          store.commit('set_profile', my_info.value)
          Swals.Done('پروفایل شما با موفقیت ویرایش شد ', 'HomePage')
        } else {
          Swals.Fault('متاسفانه پروفایل شما ویرایش نشد!')
        }
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, edit_user)
      })
    }

    async function share_prod() {
      await Share.share({
        title: my_info.value.user_code,
        text: 'شما توسط ' + my_info.value.name + ' با کد معرف : ' + my_info.value.user_code + ' به اپلیکیشن سنگین سواران دعوت شده اید',
        url: 'https://sangin-savaran.com/',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }

    return {
      my_info,
      chang_states,
      country,
      city,
      edit_user,
      loading,
      share_prod
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">پروفایل من</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div class="mb-4">
        <div class="d-flex align-items-center mb-2 pe-2">
          <p class="font-4">نام و نام خانوادگی</p>

          <img src="../assets/img/icon-editingPen.svg" alt="" class="icon-size-0-5">
        </div>

        <input v-model="my_info.name" class="rounded-pill p-3 bg-custom text-center font-4 w-100" type="text">
      </div>

      <div class="mb-4 d-flex justify-content-between">
        <div class="w-45">
          <div class="d-flex align-items-center mb-2 pe-2">
            <p class="font-4">استان</p>

            <img src="../assets/img/icon-editingPen.svg" alt="" class="icon-size-0-5">
          </div>

          <select v-model="my_info.state_id" @change="chang_states('state')"
                  class="rounded-pill p-3 bg-custom text-center shadow border-0 font-4 w-100">
            <option v-for="item in country" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>
        <div class="w-45">
          <div class="d-flex align-items-center mb-2 pe-2">
            <p class="font-4">شهر</p>

            <img src="../assets/img/icon-editingPen.svg" alt="" class="icon-size-0-5">
          </div>

          <select v-model="my_info.city_id" @change="chang_states('city')"
                  class="rounded-pill p-3 bg-custom text-center shadow border-0 font-4 w-100">
            <option v-for="item in city" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>
      </div>

      <div class="mb-4">
        <p class="font-4">شماره همراه</p>

        <p class="rounded-pill p-3 bg-custom text-center font-4 w-100" type="text">{{ my_info.phone }}</p>
      </div>

      <div class="mb-5 position-relative">
        <p class="font-4">کد معرف</p>

        <p class="rounded-pill p-3 bg-custom text-center font-4 w-100" type="text">{{ my_info.user_code }}</p>
        <img @click="share_prod" style="top: 39%" src="../assets/img/icon-shareBgWhite.svg" alt="" class="icon-size-5 position-absolute start-1">
      </div>

      <div class="d-flex justify-content-center">
        <p @click="edit_user"
           class="font-4 p-3 w-35 rounded-pill bg-color shadow-custom text-center text-white font-bold">ثبت</p>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>